import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { useViewType, ViewType } from '@eika/hooks';
import { DarkSkeleton } from '@eika/skeleton';

import { Content } from '../../components/shared/Content';
import LoanRepaymentPlanSkeletonMobileItem from './LoanRepaymentPlanSkeletonMobileItem';

const LoanRepaymentPlanSkeleton: React.FC = () => {
    const viewType = useViewType();

    if (viewType === ViewType.mobile) {
        return (
            <Content>
                <div className="loan-repayment-plan-skeleton__button-container">
                    {Array.from(Array(10)).map((_, index) => (
                        <DarkSkeleton
                            className="loan-repayment-plan-skeleton__button"
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            height={24}
                            width={40}
                        />
                    ))}
                </div>
                <ul className="loan-repayment-plan-skeleton__list">
                    {Array.from(Array(10)).map((_, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <LoanRepaymentPlanSkeletonMobileItem key={index} />
                    ))}
                </ul>
            </Content>
        );
    }
    return (
        <>
            <div className="loan-repayment-plan-skeleton-desktop__header">
                {Array.from(Array(6)).map((_, index) => (
                    <DarkSkeleton
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        height={16}
                        width={50}
                    />
                ))}
            </div>
            <div className="loan-repayment-plan-skeleton-desktop__row">
                {Array.from(Array(6)).map((_, index) => (
                    <Skeleton
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        height={16}
                        width={50}
                    />
                ))}
            </div>
            {Array.from(Array(12)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="loan-repayment-plan-skeleton-desktop__sub-row" key={index}>
                    {Array.from(Array(6)).map((_, index) => (
                        <DarkSkeleton
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            height={16}
                            width={50}
                        />
                    ))}
                </div>
            ))}
            {Array.from(Array(2)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="loan-repayment-plan-skeleton-desktop__row" key={index}>
                    {Array.from(Array(6)).map((_, index) => (
                        <Skeleton
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            height={16}
                            width={50}
                        />
                    ))}
                </div>
            ))}
        </>
    );
};

export default LoanRepaymentPlanSkeleton;
